import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { ClickEventDirective } from '@df/ui/common/click-event.directive';
import { TruncatePipe } from '@df/ui/common/truncate.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { GiftboxBasketItemComponentDef } from './giftbox-basket-item.component.def';

@Component({
    selector: 'giftbox-minibasket-item',
    templateUrl: './giftbox-minibasket-item.html',
    standalone: true,
    imports: [
        ActionComponent,
        ClickEventDirective,
        CommonModule,
        DfImageDirective,
        PriceComponent,
        ResultComponent,
        TranslatePipe,
        TruncatePipe
    ]
})
export class GiftboxMinibasketItemComponent extends GiftboxBasketItemComponentDef {}
